// extracted by mini-css-extract-plugin
export default {"wrapper":"views-ProductPage-addToCartPush-themes-BGH-styles__wrapper--ugbzX","slide":"views-ProductPage-addToCartPush-themes-BGH-styles__slide--dcB11"};